module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-main"
  }, [_c('form', {
    staticClass: "form-main__form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-main__group"
  }, [_c('div', {
    staticClass: "form-main__input-group"
  }, [_c('label', {
    staticClass: "form-main__label"
  }, [_vm._v("FIRST NAME")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    staticClass: "form-main__input",
    class: {
      'input': true, 'form-main__input--error': _vm.errors.has('firstname')
    },
    attrs: {
      "name": "firstname",
      "type": "text",
      "placeholder": "John"
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "form-main__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('firstname')),
      expression: "errors.has('firstname')"
    }],
    staticClass: "form-main__group__message"
  }, [_vm._v("Valid name is required.")])])]), _c('div', {
    staticClass: "form-main__input-group"
  }, [_c('label', {
    staticClass: "form-main__label"
  }, [_vm._v("LAST NAME")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha'),
      expression: "'required|alpha'"
    }],
    staticClass: "form-main__input",
    class: {
      'input': true, 'form-main__input--error': _vm.errors.has('lastname')
    },
    attrs: {
      "name": "lastname",
      "type": "text",
      "placeholder": "Smith"
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "form-main__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lastname')),
      expression: "errors.has('lastname')"
    }],
    staticClass: "form-main__group__message"
  }, [_vm._v("Valid last name is required.    ")])])])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('div', {
    staticClass: "form-main__input-group"
  }, [_c('label', {
    staticClass: "form-main__label"
  }, [_vm._v("EMAIL")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-main__input",
    class: {
      'input': true, 'form-main__input--error': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "form-main__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Valid email is required.")])])]), _c('div', {
    staticClass: "form-main__input-group"
  }, [_c('label', {
    staticClass: "form-main__label"
  }, [_vm._v("PHONE NUMBER")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-main__input",
    attrs: {
      "name": "phone",
      "placeholder": "000-000-0000"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._m(0)])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('div', {
    staticClass: "form-main__textarea-group"
  }, [_c('label', {
    staticClass: "form-main__label"
  }, [_vm._v("COMMENTS")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-main__textarea",
    class: {
      'form-main__textarea--error': _vm.errors.has('comments')
    },
    attrs: {
      "name": "comments",
      "type": "textarea",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "form-main__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }]
  }, [_vm._v("Leaves us a comment!")])])])]), _c('div', {
    staticClass: "form-main__button-group"
  }, [_c('button', {
    staticClass: "form-main__submit-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.formSubmitted
    }
  }, [_vm._v("Send")]), (_vm.formSubmitted) ? _c('div', {
    staticClass: "form-main__spinner"
  }) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-main__error-container"
  }, [_c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bbe5416","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/forms/form.pug
// module id = 600
// module chunks = 1